module.exports = __webpack_public_path__ + "img/browser-chrome.5886fad2.svg";